var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('s-crud',{attrs:{"searchInput":"","title":"Proveedores","config":_vm.config},on:{"doubleClick":_vm.dobleClick}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }